import { type ContentUnlock, type World } from "@iyk/music-domain-v2/client"
import { AppRedirectRoute, AppRoute } from "@iyk/react-router/client"

type Slug = World.Slug

export const AppRoutes = {
  home: AppRoute("/"),

  // users
  verifyOtp: AppRedirectRoute("/verify-otp"),

  login: AppRedirectRoute("/login"),
  logout: AppRoute("/logout"),

  settings: AppRoute("/settings"),

  resendOtp: AppRoute("/resend-otp"),

  inviteOnly: AppRoute("/invite-only"),

  worlds: {
    index: AppRoute("/worlds"),
    getStarted: AppRoute("/worlds/get-started"),
    new: AppRoute("/worlds/new"),

    home: (slug: Slug) => AppRoute(`/a/:slug`, { slug }),
    settings: (slug: Slug) => AppRoute(`/a/:slug/settings`, { slug }),
    profile: (slug: Slug) => AppRoute(`/a/:slug/profile`, { slug }),

    onboarding: {
      saveAndExit: (slug: Slug) => AppRoute(`/a/:slug/onboarding/save-and-exit`, { slug }),
      basics: (slug: Slug) => AppRoute(`/a/:slug/onboarding/basics`, { slug }),
      assets: (slug: Slug) => AppRoute(`/a/:slug/onboarding/assets`, { slug }),
      links: (slug: Slug) => AppRoute(`/a/:slug/onboarding/links`, { slug }),
      policies: (slug: Slug) => AppRoute(`/a/:slug/onboarding/policies`, { slug })
    },

    items: {
      products: {
        index: (slug: Slug) => AppRoute(`/a/:slug/items/products`, { slug }),
        detail: (slug: Slug, id: string) => AppRoute(`/a/:slug/items/products/:id`, { slug, id }),
        new: (slug: Slug) => AppRoute(`/a/:slug/items/products/new`, { slug }),
        edit: (slug: Slug, id: string) => AppRoute(`/a/:slug/items/products/:id/edit`, { slug, id })
      }
    },

    unlocks: {
      index: (slug: Slug) => AppRoute(`/a/:slug/unlocks`, { slug }),
      content: {
        new: (slug: Slug) => AppRoute(`/a/:slug/unlocks/content/new`, { slug }),
        detail: (slug: Slug, id: ContentUnlock.Id) => AppRoute(`/a/:slug/unlocks/content/:id`, { slug, id }),
        edit: (slug: Slug, id: ContentUnlock.Id) =>
          AppRoute(`/a/:slug/unlocks/content/:id/edit`, { slug, id }),
        requiredProofs: {
          edit: (slug: Slug, id: ContentUnlock.Id) =>
            AppRoute(`/a/:slug/unlocks/content/:id/required-proofs/edit`, { slug, id })
        }
      }
    },

    api: {
      worlds: {
        uploads: {
          createImageUpload: (slug: Slug) => AppRoute(`/a/:slug/api/worlds/uploads/image`, { slug })
        }
      },
      products: {
        uploads: {
          createPrimaryMediaUpload: (slug: Slug) =>
            AppRoute(`/a/:slug/api/products/uploads/primary-media`, { slug })
        }
      },
      unlocks: {
        content: {
          uploads: {
            createMediaUpload: (slug: Slug) =>
              AppRoute(`/a/:slug/api/unlocks/content/uploads/media`, { slug })
          }
        }
      }
    }
  }
}
